import { companyDocumentIdentity } from '../../../../shared/documents';

export default function DocumentLogo({ inverse = false }) {
  return <img className={`document-logo ${inverse ? 'document-logo--inverse' : ''}`} src={companyDocumentIdentity.logoUrl} alt="ICC Ingénierie" />;
}
